import { GLOBAL_NAME } from '../constants/Globals';
import { triggerHostMessageUpdateThirdPartySubject } from '../triggerHostMessage/triggerHostMessageUpdateThirdPartySubject';
export default function handleUpdateThirdPartySubject(subject) {
  window[GLOBAL_NAME].lastSentThirdPartySubject = subject;
  triggerHostMessageUpdateThirdPartySubject(subject);
}